// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_Ao8","cls2":"ClaimDetails-cls2_snw ClaimDetails-cls1_Ao8"};